var map = {
	"./special_1.png": "0ad5",
	"./special_11.png": "0f0a",
	"./special_2.png": "a120",
	"./special_22.png": "05ce",
	"./special_3.png": "44d6",
	"./special_33.png": "2e09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "091c";